export const colorMapping = {
  howBotheredFatigue : {
    aLittle : {
      color      : '#FFFFFF',
      background : '#BABABA',
    },
    somewhat : {
      color      : '#FFFFFF',
      background : '#6FB9C3',
    },
    very : {
      color      : '#FFFFFF',
      background : '#E37A3F',
    },
    extremely : {
      color      : '#FFFFFF',
      background : '#E04229',
    },
  },
  howBotheredPain : {
    aLittle : {
      color      : '#FFFFFF',
      background : '#BABABA',
    },
    somewhat : {
      color      : '#FFFFFF',
      background : '#6FB9C3',
    },
    very : {
      color      : '#FFFFFF',
      background : '#E37A3F',
    },
    extremely : {
      color      : '#FFFFFF',
      background : '#E04229',
    },
  },
  haveYouExperiencedPain : {
    sharpAndDullAndFullnessDiscomfort : {
      color      : '#FFFFFF',
      background : '#E04229',
    },
    sharpAndDull : {
      color      : '#FFFFFF',
      background : '#6FB9C3',
    },
    sharpAndFullnessDiscomfort : {
      color      : '#FFFFFF',
      background : '#FFD80C',
    },
    dullAndFullnessDiscomfort : {
      color      : '#FFFFFF',
      background : '#E37A3F',
    },
    dull : {
      color      : '#FFFFFF',
      background : '#BABABA',
    },
    sharp : {
      color      : '#FFFFFF',
      background : '#3AA203',
    },
    fullnessDiscomfort : {
      color      : '#FFFFFF',
      background : '#1E1E1E',
    },
    no : {
      color      : '#FFFFFF',
      background : '#A3CF5E',
    },
  },
  haveYouLostTimeThisPastWeek : {
    yesDueToFatigueAndPainAndOther : {
      color      : '#FFFFFF',
      background : '#E04229',
    },
    yesDueToFatigueAndPain : {
      color      : '#FFFFFF',
      background : '#E37A3F',
    },
    yesDueToFatigueAndOther : {
      color      : '#FFFFFF',
      background : '#6FB9C3',
    },
    yesDueToPainAndOther : {
      color      : '#FFFFFF',
      background : '#FFD80C',
    },
    yesDueToFatigue : {
      color      : '#FFFFFF',
      background : '#BABABA',
    },
    yesDueToPain : {
      color      : '#FFFFFF',
      background : '#1E1E1E',
    },
    yesDueToOther : {
      color      : '#FFFFFF',
      background : '#3AA203',
    },
    no : {
      color      : '#FFFFFF',
      background : '#A3CF5E',
    },
  },
  howManyDaysMiss : {
    1 : {
      color      : '#FFFFFF',
      background : '#3AA203',
    },
    2 : {
      color      : '#FFFFFF',
      background : '#FFD80C',
    },
    3 : {
      color      : '#FFFFFF',
      background : '#E37A3F',
    },
    4 : {
      color      : '#FFFFFF',
      background : '#E04229',
    },
    '5OrMore' : {
      color      : '#FFFFFF',
      background : '#1E1E1E',
    },
  },
};

export const impactTypeOptions = [
  {
    label : 'Bothered by fatigue',
    value : 'howBotheredFatigue',
  },
  {
    label : 'Bothered by pain',
    value : 'howBotheredPain',
  },
  {
    label : 'Type of Pain',
    value : 'haveYouExperiencedPain',
  },
  {
    label : 'Lost time',
    value : 'haveYouLostTimeThisPastWeek',
  },
  {
    label : 'Days missed',
    value : 'howManyDaysMiss',
  },
];

export const labelMapping = {
  howBotheredFatigue : {
    aLittle   : 'A little',
    somewhat  : 'Somewhat',
    very      : 'Very',
    extremely : 'Extremely',
  },
  howBotheredPain : {
    aLittle   : 'A little',
    somewhat  : 'Somewhat',
    very      : 'Very',
    extremely : 'Extremely',
  },
  haveYouExperiencedPain : {
    sharp                      : 'Sharp',
    dull                       : 'Dull',
    fullnessDiscomfort         : 'Fullness/discomfort',
    no                         : 'No',
    sharpAndFullnessDiscomfort : 'Sharp pain & fullness/discomfort',
    sharpAndDull               : 'Sharp pain & dull pain',
    dullAndFullnessDiscomfort  : 'Dull pain & fullness/discomfort',
    sharpAndDullAndFullnessDiscomfort :
      'Sharp pain, dull pain, & fullness/discomfort',
  },
  haveYouLostTimeThisPastWeek : {
    yesDueToFatigueAndPainAndOther : 'Yes due to fatigue, pain & other',
    yesDueToFatigueAndPain         : 'Yes due to fatigue & pain',
    yesDueToFatigueAndOther        : 'Yes due to fatigue & other',
    yesDueToPainAndOther           : 'Yes due to pain & other',
    yesDueToFatigue                : 'Yes due to fatigue',
    yesDueToPain                   : 'Yes due to pain',
    yesDueToOther                  : 'Yes due to other',
    no                             : 'No',
  },
  howManyDaysMiss : {
    1         : '1',
    2         : '2',
    3         : '3',
    4         : '4',
    '5OrMore' : '5 or more',
  },
};

export const keyMapping = {
  haveYouExperiencedPain : ({ sharp, dull, fullnessDiscomfort }) =>
    sharp && dull && fullnessDiscomfort
      ? 'sharpAndDullAndFullnessDiscomfort'
      : sharp && dull
        ? 'sharpAndDull'
        : sharp && fullnessDiscomfort
          ? 'sharpAndFullnessDiscomfort'
          : dull && fullnessDiscomfort
            ? 'dullAndFullnessDiscomfort'
            : dull
              ? 'dull'
              : sharp
                ? 'sharp'
                : fullnessDiscomfort
                  ? 'fullnessDiscomfort'
                  : 'no',
  haveYouLostTimeThisPastWeek : ({
    yesDueToFatigue,
    yesDueToOther,
    yesDueToPain,
  }) =>
    yesDueToFatigue && yesDueToPain && yesDueToOther
      ? 'yesDueToFatigueAndPainAndOther'
      : yesDueToFatigue && yesDueToPain
        ? 'yesDueToFatigueAndPain'
        : yesDueToFatigue && yesDueToOther
          ? 'yesDueToFatigueAndOther'
          : yesDueToPain && yesDueToOther
            ? 'yesDueToPainAndOther'
            : yesDueToFatigue
              ? 'yesDueToFatigue'
              : yesDueToPain
                ? 'yesDueToPain'
                : yesDueToOther
                  ? 'yesDueToOther'
                  : 'no',
};
